<div
  class="modal"
  [class.minimized]="minimized"
  [ngClass]="appearance"
  (mousedown)="bringToFront()"
  >
  <div class="modal-heading" (dblclick)="minimized && toggleCollapse()">
    @if (icon && minimized) {
      <mat-icon
        [svgIcon]="icon"
        class="modal-heading-icon"
        />
    }

    <div class="modal-heading-title">{{ title }}</div>

    @if (minimized && minimizedStatus) {
      <div class="modal-heading-status" data-testid="modal-minimized-status">{{ minimizedStatus.text }}</div>
      @if (minimizedStatus.percent !== null) {
        <div class="modal-heading-progress" data-testid="modal-minimized-progress">
          <div class="modal-heading-progress-fill" [style.width.%]="minimizedStatus.percent"></div>
        </div>
      }
    }

    <div class="modal-heading-divider"></div>

    @if (collapsible) {
      <button
        type="button"
        class="modal-heading-icon modal-heading-button"
        [attr.aria-label]="minimized ? 'Expand' : 'Minimize'"
        [appTooltip]="minimized ? 'Expand' : 'Minimize'"
        (click)="toggleCollapse()"
      >
        <mat-icon [svgIcon]="minimized ? 'expand' : 'collapse'" aria-hidden="true" class="modal-heading-glyph" />
      </button>
    }

    @if (expandable) {
      <button
        type="button"
        class="modal-heading-icon modal-heading-button"
        aria-label="Expand"
        (click)="expand()"
      >
        <mat-icon svgIcon="expand" aria-hidden="true" class="modal-heading-glyph" />
      </button>
    }

    <button
      type="button"
      class="modal-heading-icon modal-heading-button"
      aria-label="Close"
      appTooltip="Close"
      [attr.data-testid]="closeTestId"
      (click)="close()"
    >
      <mat-icon svgIcon="close2" aria-hidden="true" class="modal-heading-glyph" />
    </button>
    </div>

    <div class="modal-body">
      <ng-template #modalAnchor />
    </div>

    @if (resize && !minimized) {
      <mat-icon
        class="resize-icon"
        svgIcon="resize"
        (mousedown)="handleResize($event)"
        />
    }
  </div>
